export class Deferred<T> {
    public readonly promise: Promise<T>;
    public resolve!: (result: T) => void;
    public reject!: (error: unknown) => void;

    public constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
